export default __webpack_public_path__ + "static/D-Vert-8ff0b06fa26d9aeede7d3dda808d0f61.svg";